import React from "react";
import classes from "./SelectPartial.module.scss";
import { Tooltip, ButtonToolbar, OverlayTrigger } from "react-bootstrap";

const tooltip = (
  <Tooltip id="tooltip">
    1. Minimal - suitable for light clients that can only generate classic
    invoices <br /> 2. Normal - default value; suitable for all invoice types,
    including advances, credit notes, and others <br /> 3. Maximal - supports
    the same invoice types as Normal, but includes all (rarely used) invoice
    data defined by the Peppol and UBL formats
  </Tooltip>
);

const SelectPartial = ({ onChoosePartialHandler, value }) => {
  return (
    <div className={`d-flex flex-column ${classes["select-container"]}`}>
      <label htmlFor="partials" className="mb-2 font-weight-bold">
        Choose "complexity" option
      </label>
      <select
        name="partials"
        id="partials"
        onChange={(e) => onChoosePartialHandler(e.target.value)}
        className="px-2"
        defaultValue={value}
      >
        <option value="Minimal">Minimal</option>
        <option value="Normal">Normal</option>
        <option value="Maximal">Maximal</option>
      </select>
      <ButtonToolbar>
        <OverlayTrigger placement="right" overlay={tooltip}>
          <button>
            <svg
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.41656 1.4125C4.99542 1.4125 1.4125 4.9953 1.4125 9.41656C1.4125 13.8377 4.9953 17.4206 9.41656 17.4206C13.8377 17.4206 17.4206 13.8378 17.4206 9.41656C17.4206 4.99542 13.8378 1.4125 9.41656 1.4125ZM9.41656 0C14.6182 0 18.8331 4.21572 18.8331 9.41656C18.8331 14.6182 14.6174 18.8331 9.41656 18.8331C4.21491 18.8331 0 14.6174 0 9.41656C0 4.21491 4.21572 0 9.41656 0Z"
                fill="#00436D"
              />
              <path
                d="M9.88754 11.3001C9.88754 11.6901 9.5713 12.0063 9.18128 12.0063C8.79111 12.0063 8.47503 11.6901 8.47503 11.3001V10.9432C8.47503 9.9224 8.93946 9.39319 9.96462 8.79603C9.93876 8.811 10.2641 8.62309 10.3494 8.57217C11.2145 8.05604 11.5354 7.60783 11.5354 6.57117C11.5354 5.40461 10.7235 4.6542 9.18129 4.6542C7.77117 4.6542 6.82701 5.74575 6.82701 7.00832C6.82701 7.39834 6.51093 7.71458 6.12076 7.71458C5.73074 7.71458 5.41451 7.39834 5.41451 7.00832C5.41451 5.00749 6.94179 3.2417 9.18129 3.2417C11.4798 3.2417 12.9479 4.59855 12.9479 6.57117C12.9479 8.17082 12.3281 9.03628 11.0734 9.78511C10.9778 9.84218 10.6414 10.0364 10.6756 10.0165C10.0417 10.3857 9.88756 10.5615 9.88756 10.9432L9.88754 11.3001ZM9.13415 15.0667C8.61406 15.0667 8.19253 14.6452 8.19253 14.1251C8.19253 13.605 8.61406 13.1833 9.13415 13.1833C9.65423 13.1833 10.0758 13.605 10.0758 14.1251C10.0758 14.6452 9.65423 15.0667 9.13415 15.0667Z"
                fill="#00436D"
              />
            </svg>
          </button>
        </OverlayTrigger>
      </ButtonToolbar>
    </div>
  );
};

export default SelectPartial;
